import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import Checkbox from "@mui/material/Checkbox";
import { Box } from "@vk-hr-tek/ui/Box";
import { Tooltip } from "@vk-hr-tek/ui/Tooltip";
import { InputTooltip } from "@vk-hr-tek/ui/InputTooltip";
import { Typography } from "@vk-hr-tek/ui/Typography";
import { MultipleAutocompleteInput } from "../../MultipleAutocompleteInput/index.js";
const EmployeesInput = (t0)=>{
    const $ = c(16);
    const { name, label, placeholder, hasEmployees, loading, loadEmployees, renderTags, validate, wrapperTooltipText, inputTooltipText } = t0;
    const renderOption = _temp;
    const t1 = !hasEmployees;
    const t2 = placeholder || label;
    let t3;
    if ($[0] !== inputTooltipText) {
        t3 = inputTooltipText ? /*#__PURE__*/ jsx(InputTooltip, {
            description: "inputTooltipText"
        }) : null;
        $[0] = inputTooltipText;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== label || $[3] !== loadEmployees || $[4] !== loading || $[5] !== name || $[6] !== renderTags || $[7] !== t1 || $[8] !== t2 || $[9] !== t3 || $[10] !== validate) {
        t4 = /*#__PURE__*/ jsx(Box, {
            children: /*#__PURE__*/ jsx(MultipleAutocompleteInput, {
                type: "load",
                disabled: t1,
                loading: loading,
                testId: "test-id-employees-multiple-autocomplete-input",
                name: name,
                label: label,
                placeholder: t2,
                tooltip: t3,
                loadItems: loadEmployees,
                renderTags: renderTags,
                renderOption: renderOption,
                validate: validate
            })
        });
        $[2] = label;
        $[3] = loadEmployees;
        $[4] = loading;
        $[5] = name;
        $[6] = renderTags;
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
        $[10] = validate;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== hasEmployees || $[13] !== t4 || $[14] !== wrapperTooltipText) {
        t5 = /*#__PURE__*/ jsx(Box, {
            display: "flex",
            flexDirection: "column",
            children: /*#__PURE__*/ jsx(Tooltip, {
                title: wrapperTooltipText,
                placement: "right",
                disabled: hasEmployees,
                children: t4
            })
        });
        $[12] = hasEmployees;
        $[13] = t4;
        $[14] = wrapperTooltipText;
        $[15] = t5;
    } else t5 = $[15];
    return t5;
};
function _temp(option, value) {
    const isChecked = !!value && value.some((item)=>item === option.value);
    return /*#__PURE__*/ jsxs(Box, {
        py: "8",
        display: "flex",
        alignItems: "center",
        children: [
            /*#__PURE__*/ jsx(Checkbox, {
                checked: isChecked,
                color: "primary"
            }),
            /*#__PURE__*/ jsxs(Box, {
                display: "flex",
                flexDirection: "column",
                children: [
                    /*#__PURE__*/ jsx(Typography, {
                        variant: "body3",
                        children: `${option.label}${option.prefix ? `, ${option.prefix}` : ""}`
                    }),
                    /*#__PURE__*/ jsx(Typography, {
                        variant: "caption",
                        color: "text.light.tertirary",
                        children: option.position
                    })
                ]
            })
        ]
    });
}
export { EmployeesInput };
